import type React from "react";
import EditingInformationPanelView, {
	type EditingInformationPanelProps,
} from "@/features/editing/hooks/useEditingInformationPanelView";

export const EditingInformationPanel: React.FC<EditingInformationPanelProps> = (props) => {
	return <EditingInformationPanelView {...props} />;
};

export type { EditingInformationPanelProps };

export default EditingInformationPanel;
